var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCooldownBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 69,
    viewBox: "0 0 66 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r0u9hjmyya",
    d: "M0 0h66v69H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g53udntgrb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r0u9hjmyya"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g53udntgrb)",
    fill: "#586CAA"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 30.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 28,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 15,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 51,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 88,
    r: 44
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooldownBackground);
export default __webpack_public_path__ + "static/media/cooldown_background.759259802dc61ddad40ae6995ee74c97.svg";
export { ForwardRef as ReactComponent };